import { trackEvent } from "@faire/web--source/common/trackEvent";
import trackClick from "@faire/web-api--source/api/click-track/post";
import { IClickInfo } from "@faire/web-api--source/indigofair/data/IClickInfo";
export var allMakersMakerClicked = function(brandToken) {
    trackEvent("/all-makers/maker-page/".concat(brandToken));
};
export var trackBrandClick = function(token, container_name, request_id) {
    trackClick(IClickInfo.build({
        token: token,
        request_id: request_id,
        container_name: container_name,
        type: IClickInfo.Type.BRAND
    }));
};
export var trackProductClick = function(token, container_name, request_id, product_metadata) {
    trackClick(IClickInfo.build({
        token: token,
        request_id: request_id,
        container_name: container_name,
        type: IClickInfo.Type.PRODUCT,
        product_metadata: product_metadata
    }));
};
export var trackEditCartItemEvent = function(productQuantityInCart, newQuantity, containerName, productOptionToken, inSavedForLaterSection) {
    if (newQuantity !== productQuantityInCart) {
        var action;
        if (newQuantity === 0) {
            action = inSavedForLaterSection ? "delete_item_saved_for_later" : "delete_item";
        } else if (newQuantity > productQuantityInCart) {
            action = "increase_quantity";
        } else {
            action = "decrease_quantity";
        }
        trackEvent("container/".concat(containerName, "/edit_cart_item/").concat(action, "/").concat(productOptionToken));
    }
};
